export default class SettingsService {
	static get $inject(){ return []; }

	constructor(){
		
	}

	get notifications(){
		return {
			delaySeconds: 7
		};
	}

}



/** WEBPACK FOOTER **
 ** ./src/services/app/settings.service.js
 **/